/**
 * Custom hooks for fetching PO Line Detail data
 */

import {
	usePOLineGetSummary,
	usePOLineGetChecklistStatus,
	usePOLineGetLinkedDeliveries,
	usePOLineGetReleaseReadiness,
	usePOLineGetTraceabilityCertificatesStatus,
	usePOLineGetQcItpStatus,
} from '@/shared/api/generated/poline/poline';

/**
 * Hook for fetching PO Line summary data
 */
export function usePoLineSummary(identifier: string | undefined, lineId: string | undefined) {
	return usePOLineGetSummary(
		{ identifier: identifier!, id: lineId! },
		{ query: { enabled: !!identifier && !!lineId, staleTime: 5 * 60 * 1000 } }
	);
}

/**
 * Hook for fetching PO Line checklist status
 */
export function usePoLineChecklist(identifier: string | undefined, lineId: string | undefined) {
	return usePOLineGetChecklistStatus(
		{ identifier: identifier!, id: lineId! },
		{ query: { enabled: !!identifier && !!lineId, staleTime: 5 * 60 * 1000 } }
	);
}

/**
 * Hook for fetching PO Line linked MTO items
 */
export function usePoLineMto(identifier: string | undefined, lineId: string | undefined, page?: number) {
	return usePOLineGetLinkedDeliveries({ identifier: identifier!, id: lineId! }, page ? { page } : undefined, {
		query: { enabled: !!identifier && !!lineId, staleTime: 5 * 60 * 1000 },
	});
}

/**
 * Hook for fetching PO Line release readiness
 */
export function usePoLineReleaseReadiness(identifier: string | undefined, lineId: string | undefined) {
	return usePOLineGetReleaseReadiness(
		{ identifier: identifier!, id: lineId! },
		{ query: { enabled: !!identifier && !!lineId, staleTime: 5 * 60 * 1000 } }
	);
}

/**
 * Hook for fetching PO Line traceability & certificates
 */
export function usePoLineTraceabilityCerts(identifier: string | undefined, lineId: string | undefined) {
	return usePOLineGetTraceabilityCertificatesStatus(
		{ identifier: identifier!, id: lineId! },
		{ query: { enabled: !!identifier && !!lineId, staleTime: 5 * 60 * 1000 } }
	);
}

/**
 * Hook for fetching PO Line QC/ITP status
 */
export function usePoLineQcItpStatus(identifier: string | undefined, lineId: string | undefined) {
	return usePOLineGetQcItpStatus(
		{ identifier: identifier!, id: lineId! },
		{ query: { enabled: !!identifier && !!lineId, staleTime: 5 * 60 * 1000 } }
	);
}
